import { getCookie } from "../utils/cookies";
import {
    ACCOUNT_SWITCH_USER_VIEW,
    SUBSCRIPTION_CHECK_SUBSCRIPTION_TYPE,
    SUBSCRIPTION_CHECK_WHITELISTED_API,
    ACCOUNTS_COOKIE_KEY,
    ACTIVE_ACCOUNT_COOKIE_KEY
} from "../utils/constants";
import axios from "axios";
import { Service } from 'axios-middleware';
import { appendFilterToExistingUrl } from "../utils/common";
import { matchUrlPattern } from "../utils/util";
import { ALLOW_WHEN_IN_USER_VIEW, NON_USER_FILTER_WHITELIST } from "../routes/Filters";
import { baseRoutes as routes } from "../routes/routesConfig";
import { SetClientLayoutOrg } from "../redux/Organization/organizationReducer";
import { endPoints } from "./endpoints";
import {getSubscriptionState} from "../component/Subscription/Children/subscriptionDisplayUtils";

// export const base_url = "http://127.0.0.1:8000/api/v1";
// export const base_url = "/api/v1";
export const base_url = `${process.env.REACT_APP_BASE_SERVER_URL}${process.env.REACT_APP_BASE_SERVER_URL_VERSION}`;
const service = new Service(axios);

let latestView = null
let profileData = null
export const apiServiceVisionMiddleware = ({ getState }) => (next) => (action) => {
    const { profile } = getState()
    latestView = profile?.viewingAs
    profileData = profile
    return next(action)
}

let localDispatch
export const setDispatch = (dispatch) => {
    localDispatch = dispatch;
};

export const isSubscriptionActive = (callUrl) => {
    if (!profileData?.profile?.data) {
        return true;
    }

    const subState = getSubscriptionState(profileData.profile.data);
    let allow = true;
    if (
        SUBSCRIPTION_CHECK_SUBSCRIPTION_TYPE.includes(profileData.profile?.data?.usersubscriptionmapping?.subscription?.name) &&
        !SUBSCRIPTION_CHECK_WHITELISTED_API.includes(callUrl.split("?")[0]) &&
        subState?.can_use_paid_features === false
    ) {
        allow = false
    }
    return allow
};

export const isBlockAllowed = (config) => {
    const { url: _url } = config
    if (latestView?.data?.id === ACCOUNT_SWITCH_USER_VIEW) {
        if (config.method !== "get" && !ALLOW_WHEN_IN_USER_VIEW.some(i => matchUrlPattern(_url, i))) {
            return true
        }
    }
    return false
}


service.register({
    onRequest(config) {
        const { url: _url, headers } = config

        const { Authorization, ...other } = headers

        const anonymousEndpoints = [
            endPoints.partner.config,
            endPoints.auth.login,
            endPoints.auth.googleLogin,
            endPoints.auth.register,
            endPoints.auth.forgot_password,
            endPoints.auth.verify_forgot_password,
            endPoints.auth.verify_email,
            endPoints.auth.resend_verify_email,
            endPoints.auth.refresh_token,
        ];

        const isAnonymous = anonymousEndpoints.some((endpoint) => _url?.includes(endpoint));

        if (isAnonymous) {
            return config;
        }


        if (!isSubscriptionActive(_url)) {
            throw new Error("No valid subscription");
        }
        if (isBlockAllowed(config)) {
            throw new Error("You can't do the functionality in User view");
        }

        if (latestView.data?.id === ACCOUNT_SWITCH_USER_VIEW && latestView.data?.userId && config.method === "get" && !NON_USER_FILTER_WHITELIST.some(i => matchUrlPattern(_url, i))) {
            let newUrl = appendFilterToExistingUrl(_url, { filter_users: latestView.data?.userId });
            return { ...config, url: newUrl }
        } else {
            if (profileData.isClientLayout) {
                return { ...config, headers: { ...other } };
            } else {
                return { ...config, headers: { ...other, Authorization: Authorization } };
            }
        }
    },
    onResponse(response) {
        let responseData;
        try {
            if (typeof response.data === 'object') {
                responseData = response.data;
            } else if (typeof response.data === 'string') {
                responseData = JSON.parse(response.data);
            } else {
                return response;
            }
            if (responseData?.data?.organization) {
                localDispatch(SetClientLayoutOrg(responseData.data.organization))
            }

        } catch (error) {
            return response;
        }
        return response;
    }

});

function matchPath(urlToCheck, routes) {
    for (const route of routes) {
        if (route.regex) {
            if (urlToCheck.match(route.regex)) {
                return true;
            }
        } else {
            if (urlToCheck === route.path) {
                return true;
            }
        }
    }
    return false;
}

const apiService = () => {
    const defaultOptions = {
        baseURL: base_url,
        headers: {
            // "Access-Control-Expose-Headers": '*',
            "Content-Type": "application/json",
            // 'Access-Control-Allow-Origin': 'https://144.126.255.85'
        },
    };
    let instance = axios.create(defaultOptions);
    instance.interceptors.request.use(function (config) {
        // List of endpoints that should NEVER include the Authorization header
        const anonymousEndpoints = [
            endPoints.partner.config,
            endPoints.auth.login,
            endPoints.auth.googleLogin,
            endPoints.auth.register,
            endPoints.auth.forgot_password,
            endPoints.auth.verify_forgot_password,
            endPoints.auth.verify_email,
            endPoints.auth.resend_verify_email,
            endPoints.auth.refresh_token,
        ];

        const isAnonymous = anonymousEndpoints.some(endpoint => {
            if (endpoint === endPoints.auth.register) {
                // Register endpoint (used for create user) is only anonymous on POST.
                // GET/PATCH on user/users/ (e.g. user details) IS authenticated.
                return config.url.includes(endpoint) && config.method?.toLowerCase() === 'post';
            }
            return config.url.includes(endpoint);
        });

        let token = null;
        const activeId = getCookie(ACTIVE_ACCOUNT_COOKIE_KEY);
        if (activeId) {
            try {
                const accounts = JSON.parse(getCookie(ACCOUNTS_COOKIE_KEY) || "[]");
                const activeAcc = accounts.find((acc) => acc.id.toString() === activeId.toString());
                if (activeAcc) token = activeAcc.access;
            } catch (e) { }
        }

        if (!isAnonymous && token !== null) {
            // Check if routes is defined (handling circular dependency)
            if (typeof routes !== 'undefined' && routes.client && routes.public) {
                if (!matchPath(window.location.pathname, [...routes.client, ...routes.public])) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            } else {
                // Fallback if routes is undefined
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    });
    return instance;
};

export default apiService();


/** @deprecated Prefer getGlobalWebsocketUrl + subscribeChat from realtimeSocket.js */
export const getWebsocketUrl = (clientId) => {
    let baseUrl = process.env.REACT_APP_WEBSOCKET_URL
    let token = null;
    const activeId = getCookie(ACTIVE_ACCOUNT_COOKIE_KEY);
    if (activeId) {
        try {
            const accounts = JSON.parse(getCookie(ACCOUNTS_COOKIE_KEY) || "[]");
            const activeAcc = accounts.find((acc) => acc.id.toString() === activeId.toString());
            if (activeAcc) token = activeAcc.access;
        } catch (e) { }
    }
    // User-scoped URL; clientId kept for backward compat query only
    if (clientId) {
        return `${baseUrl}?token=${token}&client=${clientId}`
    }
    return `${baseUrl}?token=${token}`
}
